










































import { EmployeApi } from "../api/EmployeApi";
import PlanningModal from "./PlanningModal.vue";
import PlanningsList from "./EmployePlanningsEditPartials/PlanningsList.vue";
import PlanningsRotation from "./EmployePlanningsEditPartials/PlanningsRotation.vue";
import PlanningPreview from "./EmployePlanningsEditPartials/PlanningPreview.vue";

export default {
    name: "EmployePlanningsEdit",
    components: {
        PlanningPreview,
        PlanningsRotation,
        PlanningsList,
        PlanningModal,
    },
    props: {
        employeId: Number,
    },
    data() {
        return {
            plannings: [],
            selectedPlanningId: null,
            newPlanning: false,
            EmployeApi: new EmployeApi(),
        };
    },
    created() {
        if (this.employeId) {
            this.refreshPlanningList();
        }
    },
    methods: {
        createPlanning() {
            this.newPlanning = true;
            this.selectedPlanningId = null;
        },
        editPlanning(planningId: number) {
            this.newPlanning = false;
            this.selectedPlanningId = planningId;
        },
        onPlanningModalClose() {
            this.selectedPlanningId = null;
            this.newPlanning = false;
            this.refreshPlanningList();
        },
        refreshPlanningList() {
            let self = this;
            self.EmployeApi.getPlannings(self.employeId).then(function (
                response
            ) {
                self.plannings = response;
            });
        },
    },
    watch: {
        plannings: {
            immediate: true,
            deep: true,
            handler: function () {
                let self = this;
                setTimeout(function () {
                    self.$refs.planningPreview.refreshPlanning();
                }, 1000);
            },
        },
    },
};
